import VotingService from 'src/modules/voting/votingService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';
import { showVotingBulkSummary } from 'src/view/voting/form/VotingBulkSummaryModal';

const prefix = 'VOTING_FORM';

const votingFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: votingFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await VotingService.find(id);
      }

      dispatch({
        type: votingFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: votingFormActions.INIT_ERROR,
      });

      getHistory().push('/voting');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: votingFormActions.CREATE_STARTED,
      });

      const result = await VotingService.create(values);

      dispatch({
        type: votingFormActions.CREATE_SUCCESS,
      });

      if (result?.summary) {
        showVotingBulkSummary(result.summary);

        //stay on the form when nothing was created so the user can fix the data and retry
        if (result.summary.created.length === 0) {
          return;
        }
      } else {
        Message.success(
          i18n('entities.voting.create.success'),
        );
      }

      getHistory().push('/voting');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: votingFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: votingFormActions.UPDATE_STARTED,
      });

      await VotingService.update(id, values);

      dispatch({
        type: votingFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.voting.update.success'),
      );

      getHistory().push('/voting');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: votingFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default votingFormActions;
